import Link from 'next/link';
import { IconNamedComponent } from './icon.types';
import { icons } from './icons';

export const Icon: IconNamedComponent = ({ name, link, ...rest }) => {
  const Component = icons[name];

  if (link)
    return (
      <Link
        href={link}
        className="cursor-pointer hover:text-amber-300 duration-300 h-max"
      >
        <Component {...rest} />
      </Link>
    );

  return <Component {...rest} />;
};
